import React from 'react';

import * as S from './styles';

function Plus() {
  return <S.Tiplus />;
}

export default Plus;